import $ from 'jquery';
import '../vendor/jquery-livequery.min.js'

// Actions
const toggleForm = () => {
    $('#block-kontakt').slideToggle('fast');
    $('.contactLeft > button').toggleClass('btn-secondary');
    $('.contactLeft > button').toggleClass('btn-primary');
    $('.contactLeft > button > svg').toggleClass('contactRotate');
};

const onOnce = (selector, func) => {
    const DOM = $('.main-container');
    DOM.livequery(selector, () => {
        func();
        DOM.expire(selector);
    });
};

// Handlers
$('.contactLeft > button').click(e => {
    toggleForm();
});

// Init
$(document).ready(() => {
    setTimeout(() => {
        onOnce('#block-kontakt', () => {
            onOnce('.contactContainer > .contactLeft', () => {
                $('#block-kontakt').insertAfter($('.contactContainer'));
        
                onOnce('div[data-drupal-messages]', () => {
                    $('div[data-drupal-messages]').insertAfter($('.webform-submission-form'));
                    $('div[data-drupal-messages]').css('display', 'block');
    
                    let isError = false;
    
                   $('.js-form-item input').each((i, e) => {
    
                       if($(e).hasClass('error') && !isError) {
                            
                           $('div[data-drupal-messages]').css('display', 'none');
                           toggleForm();
                           isError = true;
                           
                       } else if (i === $('.js-form-item input').length - 1 && !isError) {
    
                           toggleForm();
                           const offset = $('div[data-drupal-messages]').offset();
                           $('html, body').animate({
                               scrollTop: offset.top - window.outerHeight / 2
                           }, 259);

                       }
                   });
                });
            });

            // Right styling
            setTimeout(() => {
                $('textarea').each((i, e) => {
                    if($(e).val() === '') {
                        $(e).addClass('taReq');
                    }

                    $(e).focus(() => {
                        if($(e).val() === '') {
                            $(e).removeClass('taReq');
                        } else {
                        }
                    });
    
                    $(e).focusout(() => {
                        if($(e).val() === '') {
                            $(e).addClass('taReq');
                        } else {
                        }
                    });
                });
            }, 1);

            // Input field
            setTimeout(() => {
                $('input').each((i, e) => {
                    if($(e).val() === '') {
                        $(e).addClass('taReqInput');
                    }

                    $(e).focus(() => {
                        if($(e).val() === '') {
                            $(e).removeClass('taReqInput');
                        } else {
                        }
                    });
    
                    $(e).focusout(() => {
                        if($(e).val() === '') {
                            $(e).addClass('taReqInput');
                        } else {
                        }
                    });
                });
            }, 1);
        });
    }, 1);
});